import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import DrafteJObModel from './UI/Modal/Modal.js';
import WorkIcon from '@mui/icons-material/Work';
import { UseIcon } from './hooks/UseIcon.js';
import DraftsIcon from '@mui/icons-material/Drafts';
import '../assets/css/Cogen.css';
import Spinner from 'react-bootstrap/Spinner';
import ArchiveIcon from '@mui/icons-material/Archive';
import '../assets/css/Responsiveness.css';
import { Header, Footer } from './Container.js';
import JobOpportunities from './features/client/JobOpportunities.js';
import { ReqGet, ReqPost } from '../config/Requests.js';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import { hideLoader, showLoader } from '../helper/loader.js';
// import Spinner from './UI/Spinner/Spinner.js';
import './UI/Spinner/spinner.css';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { dateFormatter } from '../helper/dateFormater.js';
import RemoveDublication from '../helper/removeDublication.js';
import { toast } from 'react-toastify';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';

const JobPaused = lazy(() => import('./features/client/JobPaused.js'));
const JobArchive = lazy(() => import('./features/client/ArchiveJobs.js'));
const JobDraft = lazy(() => import('./features/client/JobDraft.js'));

function Client() {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const navigate = useNavigate();
	const profile = useSelector(state => state.auth.profile);

	const [key, setKey] = useState(() =>
		profile.is_subscribed === 1 ? 'Publish' : 'Publish'
	);
	const [publishedJobs, setPublishedJobs] = useState([]);
	const [pausedJobs, setPausedJobs] = useState([]);
	const [draftedJobs, setDraftedJobs] = useState([]);
	const [publishRequest, setPublishRequest] = useState(false);
	const [pauseRequest, setPauseRequest] = useState(false);
	const [draftRequest, setDraftRequest] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [filledJobs, setFilledJobs] = useState([]);
	const [filledRequests, setFilledRequests] = useState(false);
	const [show, setShow] = useState(false);
	const [jobId, setJobId] = useState('');
	const [jobStartDate, setJobStartDate] = useState('');
	const [cancelModel, setCancelModel] = useState(false);
	const [filledJobModel, setFilledJobModel] = useState(false);
	const [pauseJobModel, setPauseJobModel] = useState(false);
	const [memberSelection, setMemberSelection] = useState([]);
	const [memberSelected, setMemberSelected] = useState([]);
	const [userProfile, setUserProfle] = useState({});
	const [subscribe, setSubscribe] = useState(false);

	useEffect(() => {
		if (window?.OneSignal) {
			window.OneSignal?.setExternalUserId &&
				window.OneSignal.setExternalUserId(profile?.user?.public_id);
		}

		setIsLoading(true);
		// ReqGet('jobs')
		// 	.then(res => {
		// 		setPublishedJobs(res.data.data);
		// 	})
		// 	.catch(err => {
		// 		console.log(err.response);
		// 		// setPublishRequest(false);
		// 	})
		// 	.finally(err => {
		// 		setIsLoading(false);
		// 	});
		ReqGet('profile')
			.then(res => {
				setUserProfle(res.data);
				if (res?.data?.is_subscribed != 1) {
					setSubscribe(true);
				} else {
					setSubscribe(false);
				}
			})
			.catch(err => {
				console.log(err.response);
				setPublishRequest(false);
			});
	}, []);

	const pauseJobHandler = id => {
		setJobId(id);
		setPauseJobModel(true);
	};

	const pauseJobConfirmed = () => {
		setPauseJobModel(false);
		setPublishRequest(true);
		ReqPost(`pause/job/${jobId}`)
			.then(res => {
				if (res.status === 200) {
					ReqGet('jobs')
						.then(res => {
							setPublishedJobs(res.data.data);
							setPublishRequest(false);
							toast.success('Job has been Paused Successfully');
						})
						.catch(err => {
							console.log(err.response);
							setPublishRequest(false);
						});
					setPauseRequest(true);
					ReqGet('Pause-jobs')
						.then(res => {
							setPausedJobs(res.data.data);
							setPauseRequest(false);
						})
						.catch(err => {
							console.log(err.response);
							setPauseRequest(false);
						});
				}
			})
			.catch(err => {
				console.log(err.response);
				setPublishRequest(false);
			});
	};

	const cancelJobHandler = id => {
		setJobId(id);
		setCancelModel(true);
	};

	const cancelJobSuccess = () => {
		setCancelModel(false);
		setPublishRequest(true);
		ReqPost(`cancel/job/${jobId}`)
			.then(res => {
				if (res.status === 200) {
					ReqGet('jobs')
						.then(res => {
							setPublishedJobs(res?.data?.data);
							setPublishRequest(false);
							toast.success('Job has been cancelled Successfully');
						})
						.catch(err => {
							console.log(err.response);
							setPublishRequest(false);
						});
				}
			})

			.catch(err => {
				console.log(err.response);
				setPublishRequest(false);
			});
	};

	const filledJobHandler = id => {
		setJobId(id);
		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				if (data) {
					setMemberSelection(
						data?.data?.members_applied_and_not_reject_or_decline
					);
				}
			})
			.catch(err => console.log(err));
		setFilledJobModel(true);
	};
	const publishPausedJobHandler = (id, params) => {
		setPauseRequest(true);
		ReqPost(`resume/job/${id}`, params)
			.then(res => {
				if (res.status === 200) {
					ReqGet('Pause-jobs')
						.then(res => {
							hideLoader();
							setPausedJobs(res.data.data);
							setPauseRequest(false);
							toast.success('Job has been resumed Successfully');
						})
						.catch(err => {
							console.log(err.response);
							setPauseRequest(false);
						});
					setPublishRequest(true);

					ReqGet('jobs')
						.then(res => {
							setPublishedJobs(res.data.data);
							setPublishRequest(false);
						})
						.catch(err => {
							console.log(err.response);
							setPublishRequest(false);
						});
				}
			})
			.catch(err => {
				console.log(err.response);
				setPauseRequest(false);
			});
	};
	const publishJobStatus = () => {
		ReqGet('jobs')
			.then(res => {
				setPublishedJobs(res.data.data);
				setPublishRequest(false);
			})
			.catch(err => {
				console.log(err.response);
				setPublishRequest(false);
			});
	};
	const publishDraftedJobHandler = id => {
		setJobId(id);
		const date = new Date();
		let todayDate = dateFormatter(date, 'MM-DD-YYYY');
		const today = new Date();
		let currentDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate(),
			0,
			0,
			0
		);
		const days = 15;
		currentDate = currentDate.setDate(currentDate.getDate() + days);
		currentDate = new Date(currentDate);
		currentDate = dateFormatter(currentDate, 'MM-DD-YYYY');

		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				if (data?.data?.start_date < currentDate) {
					setJobStartDate(data?.data?.start_date);
					setShow(true);
				} else {
					setDraftRequest(true);
					ReqPost(`publish/job/${id}`)
						.then(res => {
							if (res.status === 200) {
								ReqGet('draft-jobs')
									.then(res => {
										setDraftedJobs(res.data.data);
										setDraftRequest(false);
										toast.success('Job has been Published Successfully');
									})
									.catch(err => {
										console.log(err.response);
										setDraftRequest(false);
									});
								setPublishRequest(true);
								ReqGet('jobs')
									.then(res => {
										setPublishedJobs(res.data.data);
										setPublishRequest(false);
									})
									.catch(err => {
										console.log(err.response);
										setPublishRequest(false);
									});
							}
						})
						.catch(err => {
							console.log(err.response);
							setDraftRequest(false);
						});
				}
			})
			.catch(err => {
				console.log(err.response);
				setPublishRequest(false);
			});
	};

	const editJob = () => {
		navigate(`/${jobId}/edit-job`);
	};

	const closeModel = () => {
		setShow(false);
	};

	const _handleAddNewJob = () => {
		navigate('/jobs/create');
	};
	const handleClose = () => {
		setCancelModel(false);
	};

	const memberSelectionFun = e => {
		const { value, checked } = e.target;
		if (!checked)
			return setMemberSelected(memberSelected.filter(d1 => d1 != value));
		setMemberSelected([...memberSelected, e.target.value]);
	};
	const filledJob = () => {
		if (memberSelected?.length < 1) {
			toast.error('please select atleast 1 member to fill job');
		}

		ReqPost(`filled/job/${jobId}`, { selected_applicants: memberSelected })
			.then(res => {
				if (res.status === 200) {
					ReqGet('jobs')
						.then(res => {
							setPublishedJobs(res?.data?.data);
							setPublishRequest(false);
							toast.success('Job has been filled Successfully');
						})
						.catch(err => {
							console.log(err.response);
							setPublishRequest(false);
						});
				}
			})
			.catch(err => {
				console.log(err.response);
				setPublishRequest(false);
			});
		setFilledJobModel(false);
	};

	return (
		<Container fluid className='m-0 p-0'>
			<Header type='client' />
			<Suspense
				fallback={
					<div className='lds-ring'>
						{/* <Spinner animation='grow' variant='primary' /> */}
					</div>
				}
			>
				{/* new Pause Jobs Modal */}

				<Modal
					size='sm'
					show={pauseJobModel}
					onHide={() => setPauseJobModel(false)}
				>
					<Modal.Header className='no-border text-center'>
						<Modal.Title className='modal-title w-100 fw-bold'>
							Pause Job
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className='text-center'>
						{' '}
						Are you sure you want to pause job.
					</Modal.Body>
					<Modal.Footer className='no-border'>
						<Button
							className='w-100  fw-bold btn-logout'
							variant='primary'
							onClick={pauseJobConfirmed}
						>
							PAUSE JOB
						</Button>
						<Button
							className='w-100 fw-bold btn-logout'
							variant='danger'
							onClick={() => setPauseJobModel(false)}
						>
							CANCEL
						</Button>
					</Modal.Footer>
				</Modal>

				{/*  */}
				{/* Old Filled Job Model */}
				{/* <Modal show={filledJobModel} onHide={() => setFilledJobModel(false)} centered>
          <Modal.Header >
            <Modal.Title className="modal-title w-100" style={{ fontSize: '20px', textAlign: 'center' }}>Please Select Member to Filled Job12</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ fontSize: '18px', fontWeight: '600' }}>
            <em>
              {memberSelection?.map((data, index) => (
                <div>
                  <input onChange={(e) => memberSelectionFun(e)} type="checkbox" id={index} name="members" value={data.id} />
                  <label for="vehicle1">&nbsp;&nbsp; {data.fullname}</label><br />
                </div>
              ))}
            </em></Modal.Body>
          <Modal.Footer>
            <div style={{ margin: 'auto' }}>
              <Button variant="primary" onClick={filledJob}>
                Filled Job
              </Button> &nbsp;&nbsp;
              <Button variant="danger" onClick={() => setFilledJobModel(false)}>
                Cancel
              </Button>
            </div>
          </Modal.Footer>
        </Modal> */}
				{/* //////new  Filled Job Model */}
				<Modal
					size='sm'
					show={filledJobModel}
					onHide={() => setFilledJobModel(false)}
				>
					<Modal.Header className='no-border text-center'>
						<Modal.Title className='modal-title w-100 fw-bold'>
							Select Member
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className='text-center'>Please select applicant for this Job</p>
						<p className='text-start'>
							{memberSelection?.map((data, index) => (
								<div key={index}>
									<input
										onChange={e => memberSelectionFun(e)}
										type='checkbox'
										id={index}
										name='members'
										value={data.id}
									/>
									<label htmlFor='vehicle1'>&nbsp;&nbsp; {data.fullname}</label>
									<br />
								</div>
							))}
						</p>
					</Modal.Body>
					<Modal.Footer className='no-border '>
						<Button
							className='w-100  fw-bold btn-logout'
							variant='primary'
							onClick={filledJob}
						>
							Select Member
						</Button>
						<Button
							className='w-100 fw-bold btn-logout'
							variant='danger'
							onClick={() => setFilledJobModel(false)}
						>
							CANCEL
						</Button>
					</Modal.Footer>
				</Modal>

				{/* //////New Cancel Job Modal */}
				<Modal size='sm' show={cancelModel} onHide={handleClose}>
					<Modal.Header className='no-border text-center'>
						<Modal.Title className='modal-title w-100 fw-bold'>
							Cancel Job
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className='text-center'>
						Are you sure to want to cancel Job.
					</Modal.Body>
					<Modal.Footer className='no-border'>
						<Button
							className='w-100  fw-bold btn-logout'
							variant='primary'
							onClick={cancelJobSuccess}
						>
							YES
						</Button>
						<Button
							className='w-100 fw-bold btn-logout'
							variant='danger'
							onClick={() => setCancelModel(false)}
						>
							NO
						</Button>
					</Modal.Footer>
				</Modal>

				{/* End cancel Job Modal */}
				<DrafteJObModel
					editBtn='Edit Job'
					editJob={editJob}
					showModel={show}
					closeModel={closeModel}
					jobStartDate={jobStartDate}
				/>
				<Row className='mt-5 m-0' style={{ minHeight: 'calc(100vh - 183px)' }}>
					<Col className='ps-0 pr-6' style={{overflow:'hidden'}}>
						{
							userProfile?.is_subscribed === 1 ? (
								<Box sx={{ width: '100%' }}>
									<Box>
										<Tabs
											indicatorColor='white'
											value={value}
											onChange={handleChange}
											aria-label='basic tabs example'
											centered
											sx={{
												mb: 0,
												pb: 0,
												borderBottom: 1,
												padding: 0,
												borderColor: 'divider',
											}}
										>
											<Tab
												// icon={<PublishedWithChangesIcon />}
												// iconPosition='start'
												label={
													<Box
														sx={{
															border: '1px solid #237bdf',
															background: value === 0 ? '#237bdf' : '',
															color: value === 0 ? 'white' : '',
															borderTopLeftRadius: '10px',
															borderTopRightRadius: '10px',
															padding: '10px',
															borderBottom: 'none',
														}}
													>
														<UseIcon
															icon={key === 'Publish' ? 'jobactive' : 'job'}
															title='Published Jobs'
															simg='tab-icon'
														/>
													</Box>
												}
												{...a11yProps(0)}
											/>
											<Tab
												// icon={<PauseCircleFilledIcon />}
												// iconPosition='start'
												label={
													<Box
														sx={{
															border: '1px solid #237bdf',
															background: value === 1 ? '#237bdf' : '',
															color: value === 1 ? 'white' : '',
															borderTopLeftRadius: '10px',
															borderTopRightRadius: '10px',
															padding: '10px',
															borderBottom: 'none',
														}}
													>
														<UseIcon
															icon={key === 'Pause' ? 'pause' : 'pause'}
															title='Paused Jobs'
															simg='tab-icon'
														/>
													</Box>
												}
												{...a11yProps(1)}
											/>
											<Tab
												// icon={<DraftsIcon />}
												// iconPosition='start'
												// label='Drafted Jobs'
												label={
													<Box
														sx={{
															border: '1px solid #237bdf',
															background: value === 2 ? '#237bdf' : '',
															color: value === 2 ? 'white' : '',
															borderTopLeftRadius: '10px',
															borderTopRightRadius: '10px',
															padding: '10px',
															borderBottom: 'none',
														}}
													>
														<UseIcon
															icon={key === 'Draft' ? 'notepad' : 'notepad'}
															title='Drafted Jobs'
															simg='tab-icon'
														/>
													</Box>
												}
												{...a11yProps(2)}
											/>
											<Tab
												// icon={<ArchiveIcon />}
												// iconPosition='start'
												// label='Archive Jobs'
												label={
													<Box
														sx={{
															border: '1px solid #237bdf',
															background: value === 3 ? '#237bdf' : '',
															color: value === 3 ? 'white' : '',
															borderTopLeftRadius: '10px',
															borderTopRightRadius: '10px',
															padding: '10px',
															borderBottom: 'none',
														}}
													>
														<UseIcon
															icon={key === 'archived' ? 'jobactive' : 'job'}
															title='Archive Jobs'
															simg='tab-icon'
														/>
													</Box>
												}
												{...a11yProps(3)}
											/>
										</Tabs>
									</Box>

									<CustomTabPanel value={value} index={0}>
										<JobOpportunities
											setKey={setKey}
											pauseJobHandler={pauseJobHandler}
											filledJobHandler={filledJobHandler}
											cancelJobHandler={cancelJobHandler}
											isLoading={isLoading}
											publishedJobs={publishedJobs}
											dataType='Publish'
											_handleAddNewJob={_handleAddNewJob}
										/>
									</CustomTabPanel>
									<CustomTabPanel value={value} index={1}>
										<JobPaused
											setKey={setKey}
											publishJobStatus={publishJobStatus}
											dataType='Pause'
											_handleAddNewJob={_handleAddNewJob}
										/>
									</CustomTabPanel>
									<CustomTabPanel value={value} index={2}>
										<JobDraft
											setKey={setKey}
											publishDraftedJobHandler={publishDraftedJobHandler}
											publishJobStatus={publishJobStatus}
											isInitiated={draftRequest}
											draftedJobs={draftedJobs}
											dataType='Draft'
											_handleAddNewJob={_handleAddNewJob}
											profile={profile}
										/>
									</CustomTabPanel>
									<CustomTabPanel value={value} index={3}>
										<JobArchive
											setKey={setKey}
											publishPausedJobHandler={publishPausedJobHandler}
											isInitiated={filledRequests}
											filledJobs={filledJobs}
											dataType='archived'
											_handleAddNewJob={_handleAddNewJob}
										/>
									</CustomTabPanel>
								</Box>
							) : (
								<Modal size='sm' show={subscribe} onHide={handleClose}>
									<Modal.Header className='no-border text-center'>
										<Modal.Title className='modal-title w-100 fw-bold'>
											Subscription
										</Modal.Title>
									</Modal.Header>
									<Modal.Body className='text-center'>
										Please subscribe
									</Modal.Body>
									<Modal.Footer className='no-border'>
										<Button
											className='w-100  fw-bold btn-logout'
											variant='danger'
											onClick={() => navigate('/subscribe')}
										>
											SUBSCRIBE
										</Button>
										<Button
											className='w-100 fw-bold btn-logout'
											variant='light'
											onClick={handleClose}
										>
											CANCEL
										</Button>
									</Modal.Footer>
								</Modal>
							)
							// <Tabs
							//   activeKey={key}
							//   onSelect={k => setKey(k)}
							//   className="tabs-custom"
							// >
							//   <Tab
							//     className="mr-2 ml-2"
							//     eventKey="Draft"
							//     title={
							//       <UseIcon icon={key === "Draft" ? "notepad" : "notepad"} title="Drafted Jobs" simg="tab-icon" />
							//     }
							//   >
							//     <JobDraft publishDraftedJobHandler={publishDraftedJobHandler} isInitiated={draftRequest} draftedJobs={draftedJobs} dataType="Draft" _handleAddNewJob={_handleAddNewJob} profile={profile} />
							//   </Tab>
							// </Tabs>
						}
					</Col>
				</Row>
				<Footer />
			</Suspense>
		</Container>
	);
}

export default Client;

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}
